import { javascriptGenerator } from 'blockly/javascript'
import { registerEventGenerators } from './generators/events.js'
import { registerMotionGenerators } from './generators/motion.js'
import { registerLooksGenerators } from './generators/looks.js'
import { registerSoundGenerators } from './generators/sound.js'
import { registerLogicGenerators } from './generators/logic.js'
import { registerLoopGenerators } from './generators/loop.js'
import { registerEndGenerators } from './generators/end.js'
import { validateGeneratedCode } from './validator.js'

let generatorsRegistered = false

export function ensureGenerators() {
  if (generatorsRegistered) return
  registerEventGenerators(javascriptGenerator)
  registerMotionGenerators(javascriptGenerator)
  registerLooksGenerators(javascriptGenerator)
  registerSoundGenerators(javascriptGenerator)
  registerLogicGenerators(javascriptGenerator)
  registerLoopGenerators(javascriptGenerator)
  registerEndGenerators(javascriptGenerator)
  generatorsRegistered = true
}

export function generateProjectCode(workspace, options = {}) {
  const { initialSprites = [] } = options
  ensureGenerators()
  javascriptGenerator.init(workspace)

  const topBlocks = workspace.getTopBlocks(true)
  let userCode = ''
  for (const block of topBlocks) {
    const line = javascriptGenerator.blockToCode(block)
    userCode += Array.isArray(line) ? line[0] : line
  }

  const code = wrapAsModule(userCode, initialSprites)
  validateGeneratedCode(code)
  return code
}

function wrapAsModule(userCode, initialSprites = []) {
  const runtimeImports = `
import {
  createSprite, onStart, onSpriteTap, onCollide,
  onKey, onInterval, sleep, waitUntil, stopAll,
  say, playSound, playMusic, stopAudio,
  isTouching, yieldFrame,
} from '/sandbox/runtime.js'
`
  return `
${runtimeImports}

// Generated code from TM Studio
export function main(scene) {
  window.__PHASER_SCENE__ = scene
  window.__PHASER_SPRITES__ = {}

  for (const spriteDef of ${JSON.stringify(initialSprites)}) {
    window.__PHASER_SPRITES__[spriteDef.key] = createSprite(
      spriteDef.key, spriteDef.x, spriteDef.y, { physics: spriteDef.physics }
    )
  }

${userCode}
}
`.trim()
}
